import React, { PureComponent } from "react";
import {
  ButtonWrapper,
  Input,
  Form,
  Label,
  InputGroup,
  FormGroup,
  Button,
  LoginCardForm
} from "./styled";
import ErrorAlert from "../../components/error-alert/ErrorAlert";

type ResetPasswordFormProps = {
  failureMessage: string;
  resetPassword: (
    username: string,
    password: string,
    confirmPassword: string
  ) => Promise<any>;
  username: string;
  setFailureMessage: (message: string | null) => void;
  signup: boolean;
};

type ResetPasswordFormState = {
  password: string;
  confirmPassword: string;
  [x: number]: any;
  showSpinner: boolean;
  enableButton: boolean;
};

export default class ResetPasswordForm extends PureComponent<
  ResetPasswordFormProps,
  ResetPasswordFormState
> {
  static defaultProps = {
    failureMessage: ""
  };
  state = {
    password: "",
    confirmPassword: "",
    showSpinner: false,
    enableButton: true
  };

  passwordInput = React.createRef<HTMLInputElement>();

  resetPasswords = () => {
    this.setState({ password: "", confirmPassword: "" });
    this.passwordInput.current!.focus();
  };

  checkPasswords = () => {
    const { resetPassword, setFailureMessage } = this.props;
    const { password, confirmPassword } = this.state;
    setFailureMessage("");
    if (password === confirmPassword) {
      this.setState({ showSpinner: true, enableButton: false });
      resetPassword(this.props.username, password, confirmPassword)
        .catch(() => {
          this.setState({ showSpinner: false });
        })
        .finally(() => this.setState({ enableButton: true }));
    } else {
      setFailureMessage("New passwords do not match.");
    }
  };

  handleInputChange = (event: any) => {
    const { target } = event;
    this.setState({ [target.name]: event.target.value });
  };

  keyPressed = (event: any) => {
    if (event.key === "Enter" && this.state.enableButton) {
      this.checkPasswords();
      console.log(this.props.failureMessage);
    }
  };

  render() {
    const { failureMessage, signup } = this.props;
    const { password, confirmPassword, showSpinner, enableButton } = this.state;

    return (
      <LoginCardForm>
        <Form autoComplete="off">
          <div
            style={{
              color: "#fff",
              padding: "0.5rem 0 1rem 0",
              fontSize: "1.125rem"
            }}
          >
            {this.props.username}, please {signup ? "create" : "reset"} your
            password.
          </div>
          {failureMessage && <ErrorAlert>{failureMessage}</ErrorAlert>}
          <FormGroup className="form-group">
            <InputGroup>
              <Label className="col-sm-4 col-form-label">NEW PASSWORD</Label>
              <Input
                ref={this.passwordInput}
                name="password"
                type="password"
                value={password}
                aria-label="Password"
                aria-describedby="password-icon"
                required
                autoFocus
                onChange={this.handleInputChange}
              />
            </InputGroup>
          </FormGroup>
          <FormGroup className="form-group">
            <InputGroup>
              <Label className="col-sm-4 col-form-label">
                CONFIRM NEW PASSWORD
              </Label>
              <Input
                id="confirm-password-field"
                name="confirmPassword"
                type="password"
                value={confirmPassword}
                aria-label="ConfirmPassword"
                aria-describedby="password-icon"
                required
                onChange={this.handleInputChange}
                onKeyPress={this.keyPressed}
              />
            </InputGroup>
          </FormGroup>
          <div
            style={{
              color: "#fff",
              fontSize: "0.9rem",
              alignSelf: "center",
              fontWeight: 300,
              width: "100%"
            }}
          >
            For security reasons, your password must have a minimum length of{" "}
            <span style={{ fontWeight: "bold" }}>8 characters</span> and include
            at least{" "}
            <span style={{ fontWeight: "bold" }}>three of the four</span>{" "}
            available character types:
            <ul>
              <li>one capital letter (A-Z)</li>
              <li>one lowercase letter (a-z) </li>
              <li>one digit (0-9)</li>
              <li>one symbol (!,$,@ etc.)</li>
            </ul>
            It cannot include your username.
          </div>
          <div
            style={{
              display: "flex",
              flex: "1 1 auto",
              alignItems: "flex-end",
              justifyContent: "flex-end",
              paddingTop: "0.5rem"
            }}
          >
            <ButtonWrapper>
              <Button
                type="button"
                className="btn btn-primary"
                onClick={this.checkPasswords}
                disabled={
                  password === "" || confirmPassword === "" || !enableButton
                }
              >
                {showSpinner && (
                  <div
                    className="spinner-border spinner-border-sm"
                    style={{ marginRight: "0.5rem" }}
                    role="status"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                )}{" "}
                SUBMIT
              </Button>
            </ButtonWrapper>
          </div>
        </Form>
      </LoginCardForm>
    );
  }
}
